export default __webpack_public_path__ + "static/media/project_search_no_result.08fda607.svg";